import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconRestart = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M4 12a8 8 0 1 0 2.3-5.6' />
      <path d='M4 4v4h4' />
    </g>
  </SDIcon>
)

export default IconRestart
